/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventTimeType = "Date" | "DateTime" | "%future added value";
export type IntervalDefinitionFreqTypeEnum = "Daily" | "Monthly" | "Weekly" | "Yearly" | "%future added value";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type EventTimeAndRecurrence_event = {
    readonly isAllDay: boolean | null;
    readonly startTime: {
        readonly type: EventTimeType;
        readonly dateOrDateTime: string;
        readonly timeZone: string | null;
        readonly millis: number;
        readonly offsetMinutes: number | null;
    };
    readonly endTime: {
        readonly type: EventTimeType;
        readonly dateOrDateTime: string;
        readonly timeZone: string | null;
        readonly millis: number;
        readonly offsetMinutes: number | null;
    };
    readonly eventKey: {
        readonly externalEventId: string;
    };
    readonly eventFlexibilityErrorable: {
        readonly list?: ReadonlyArray<{
            readonly flex: string;
            readonly flexString: string;
        }> | undefined;
    };
    readonly recurrenceRules: {
        readonly firstInstanceStartTime: {
            readonly type: EventTimeType;
            readonly dateOrDateTime: string;
            readonly timeZone: string | null;
            readonly millis: number;
            readonly offsetMinutes: number | null;
        } | null;
        readonly timeZone: string;
        readonly interval: {
            readonly interval: number;
            readonly byDay: string | null;
            readonly bySetPos: ReadonlyArray<number | null> | null;
            readonly freqType: IntervalDefinitionFreqTypeEnum;
            readonly count: number | null;
            readonly untilTime: {
                readonly type: EventTimeType;
                readonly dateOrDateTime: string;
                readonly timeZone: string | null;
                readonly millis: number;
                readonly offsetMinutes: number | null;
            } | null;
        } | null;
    } | null;
    readonly annotatedEvent: {
        readonly orgTags: ReadonlyArray<{
            readonly tag: string;
            readonly state: {
                readonly active: boolean;
                readonly value: string | null;
                readonly subjectType: SubjectUrnTypeEnum;
            };
        }> | null;
    } | null;
    readonly " $refType": "EventTimeAndRecurrence_event";
};
export type EventTimeAndRecurrence_event$data = EventTimeAndRecurrence_event;
export type EventTimeAndRecurrence_event$key = {
    readonly " $data"?: EventTimeAndRecurrence_event$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventTimeAndRecurrence_event">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v1 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        (v0 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "EventTimeAndRecurrence_event",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAllDay",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "startTime",
                "plural": false,
                "selections": (v1 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "endTime",
                "plural": false,
                "selections": (v1 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventKey",
                "kind": "LinkedField",
                "name": "eventKey",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "externalEventId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "eventFlexibilityErrorable",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventFlexibilityNew",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "flex",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "flexString",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "EventFlexibilityNewList",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "RecurrenceRules",
                "kind": "LinkedField",
                "name": "recurrenceRules",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "firstInstanceStartTime",
                        "plural": false,
                        "selections": (v1 /*: any*/),
                        "storageKey": null
                    },
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntervalDefinition",
                        "kind": "LinkedField",
                        "name": "interval",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "interval",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "byDay",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bySetPos",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "freqType",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "count",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTime",
                                "kind": "LinkedField",
                                "name": "untilTime",
                                "plural": false,
                                "selections": (v1 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AnnotatedEvent",
                "kind": "LinkedField",
                "name": "annotatedEvent",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrgTag",
                        "kind": "LinkedField",
                        "name": "orgTags",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tag",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TagState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "active",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "value",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "subjectType",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Event",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '806e393831a57aebf04a1cd8ae6eacb4';
export default node;
